import Box from '@material-ui/core/Box'
import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import { makeStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import { useEffect, useState } from 'react'

import { withDisableBackdropClick } from '../../helpers/withDisableBackdropClick'
import { revealPlaidAccountNumber } from '../../models/cash'
import { hasPermission, Permissions } from '../../Permissions'

const useStyles = makeStyles({
  dialogContent: {
    textAlign: 'center',
    minWidth: '300px',
  },
  wrap: {
    background: '#E8FBFF',
    padding: '10px 30px',
    borderRadius: '5px',
    letterSpacing: '3px',
    margin: '0 auto',
    display: 'inline-block',
    fontSize: '30px',
  },
})

const TeamPlaidAccountNumber = (props: any) => {
  const [open, setOpen] = useState(false)
  function handleClose() {
    setOpen(false)
  }

  return (
    <>
      <span onClick={() => setOpen(true)}>Reveal</span>
      <Dialog open={open} onClose={withDisableBackdropClick(() => setOpen(false))}>
        <ShowPlaidAccountNumber {...props} handleClose={handleClose} />
      </Dialog>
    </>
  )
}

const ShowPlaidAccountNumber = (props: any) => {
  const { requestIsLoading } = props
  const classes = useStyles()

  if (!hasPermission(props.permissions, Permissions.ViewPlaidAccountNumber)) {
    return (
      <>
        <DialogTitle>You dont have permissions to view bank account number.</DialogTitle>
        <DialogContent className={classes.dialogContent}>
          <Typography component="div" variant="body1">
            We pay for every revealed bank account. If you need to view bank account number ask for{' '}
            <code>{Permissions.ViewPlaidAccountNumber}</code> permission to be added.
          </Typography>

          <br />
          <br />

          <Box display="flex" flexDirection="column" alignItems="center">
            <Button
              color="primary"
              variant="contained"
              onClick={props.handleClose}
              disabled={requestIsLoading}
            >
              Close
            </Button>
          </Box>
          <br />
        </DialogContent>
      </>
    )
  }

  return (
    <>
      <DialogTitle>Account number</DialogTitle>
      <DialogContent className={classes.dialogContent}>
        <Typography component="div" variant="h6" className={classes.wrap}>
          <RevealedCredentials {...props} />
        </Typography>

        <br />
        <br />

        <Box display="flex" flexDirection="column" alignItems="center">
          <Button color="primary" variant="contained" onClick={props.handleClose} disabled={requestIsLoading}>
            Close
          </Button>
        </Box>
        <br />
      </DialogContent>
    </>
  )
}

const RevealedCredentials = ({ record, accountId }: any) => {
  const [loading, setLoading] = useState(true)
  const [accountNumber, setAccountNumber] = useState(null)

  useEffect(() => {
    revealPlaidAccountNumber(record.id, accountId).then((data: any) => {
      setLoading(false)
      setAccountNumber(data.account_number)
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  if (loading) {
    return <>Loading...</>
  }

  return <span>{accountNumber}</span>
}

export default TeamPlaidAccountNumber
